export type TToastType = 'success' | 'error';

export type TToastPlacement = 'center' | 'bottom-left';

export type TToastDetail = {
  /** @deprecated Use title — kept for backward compatibility */
  text?: string;
  title?: string;
  subtitle?: string;
  type?: TToastType;
  placement?: TToastPlacement;
};

export function extractApiErrorMessage(error: unknown, fallback = 'Что-то пошло не так'): string {
  if (!error) {
    return fallback;
  }

  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  const err = error as {
    message?: string;
    data?: { message?: string };
    errors?: Record<string, string[]>;
  };

  if (err.errors && typeof err.errors === 'object') {
    const first = Object.values(err.errors).flat()[0];
    if (first?.length) {
      return first;
    }
  }

  if (typeof err.message === 'string' && err.message.trim()) {
    return err.message;
  }

  if (typeof err.data?.message === 'string' && err.data.message.trim()) {
    return err.data.message;
  }

  return fallback;
}

export function showToast(detail: TToastDetail | string, type: TToastType = 'success') {
  if (import.meta.server) {
    return;
  }

  const payload: TToastDetail = typeof detail === 'string'
    ? { title: detail, type }
    : { ...detail, type: detail.type ?? type };

  document.dispatchEvent(new CustomEvent('show-toast', {
    detail: payload,
    bubbles: true,
  }));
}
